export default __webpack_public_path__ + "27d38e82039e56ca30f9453f969c6f3f.png";